import React, { useEffect, useState } from "react";
import { selectType } from "./BenchmarkUpload";
import {
  useBenchmarksWithRows,
  useBenchmarkWithRows,
  useSensitivityLevelCodes,
} from "../../api/benchmarking/BenchmarkingAPI";
import { generateBenchmarkInfoExcel } from "../../utils/spreadsheets";
import {
  deleteBenchmarking,
  saveBenchmarkCoordinates,
  saveSensitivityCompanyId,
  saveSensitivityInformationFlag,
} from "../../api/benchmarking-control/BenchmarkingControlAPI";
import {
  featureEnumerator,
  prepareObjectForExcelUpload,
} from "./Benchmark.functions";
import {
  FieldNumber,
  ModalCompany,
} from "../project-create/CreateProject.components";
import CreateProjectSelectClientCompany from "../project-create/CreateProjectSelectClientCompany";
import PropTypes from "prop-types";
import { CreateProjectMap } from "../project-create/CreateProjectMap";
import { tranStr, translate } from "../../utils/translation";
import { BenchmarkCustomTabPanel } from "./BenchmarkView";
import { Box, Tab, Tabs } from "@mui/material";

import isEmpty from "../../validation/is-empty";
import Spinner from "../common/Spinner";
import {
  PublishButton,
  UploadButton,
} from "../post-contract-2.0/PostContractButtons.components";
import { bmAPIs } from "../../api/api-endpoints/BenchmarkingEndpoints";
import { ConfigurableForm } from "../post-contract-2.0/PostContractForm";
import { BA_ROLE, hasRoles } from "../../utils/roles";

BenchmarkInputSingle.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  icon: PropTypes.any,
};
export function BenchmarkInputSingle(props) {
  const { value, onChange, placeholder, icon } = props;
  const [focus, setFocus] = useState(false);
  let iconType = "input-icon";
  if (focus || value !== "") iconType = "input-icon-focus";

  return (
    <div className="input-container">
      <div className={iconType}>{icon}</div>
      <div className="input-col">
        {placeholder}
        <div className="input-row">
          <input
            className="b-c-search-input"
            type="text"
            value={value}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            autoComplete="off"
          ></input>
        </div>
      </div>
    </div>
  );
}

BenchmarkSelectSingle.propTypes = {
  value: PropTypes.string,
  values: PropTypes.array,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  icon: PropTypes.any,
};
export function BenchmarkSelectSingle(props) {
  const { value, values, onChange, placeholder, icon } = props;
  const [focus, setFocus] = useState(false);
  let iconType = "input-icon";
  if (focus || value !== "") iconType = "input-icon-focus";

  return (
    <div className="input-container">
      <div className={iconType}>{icon}</div>
      <div className="input-col">
        {placeholder}
        <div className="input-row">
          <select
            className="b-c-search-input"
            value={value}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
          >
            {selectOptions(values)}
          </select>
        </div>
      </div>
    </div>
  );
}

function selectOptions(values) {
  return values.map((item, i) => {
    return (
      <option key={i} value={item.value} className="option">
        {item.label}
      </option>
    );
  });
}

BenchmarkSelectSingleFilter.propTypes = {
  value: PropTypes.string,
  values: PropTypes.array,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  icon: PropTypes.any,
  filter: PropTypes.string,
};
export function BenchmarkSelectSingleFilter(props) {
  const { value, values, onChange, placeholder, icon, filter } = props;
  const [focus, setFocus] = useState(false);
  let iconType = "input-icon";
  if (focus || value !== "") iconType = "input-icon-focus";

  return (
    <div className="input-container">
      <div className={iconType}>{icon}</div>
      <div className="input-col">
        {placeholder}
        <div className="input-row">
          <select
            className="b-c-search-input"
            value={value}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
          >
            {selectOptionsFilter(values, filter)}
          </select>
        </div>
      </div>
    </div>
  );
}

function selectOptionsFilter(values, filter) {
  return values.map((item, i) => {
    if (item.type === filter || item.type === "") {
      return (
        <option key={i} value={item.value} className="option">
          {item.label}
        </option>
      );
    } else {
      return null;
    }
  });
}

BenchmarkInputDouble.propTypes = {
  value1: PropTypes.string,
  onChange1: PropTypes.func,
  value2: PropTypes.string,
  onChange2: PropTypes.func,
  placeholder: PropTypes.string,
  icon: PropTypes.any,
};
export function BenchmarkInputDouble(props) {
  const { value1, onChange1 } = props;
  const { value2, onChange2 } = props;
  const { placeholder, icon } = props;
  const [focus, setFocus] = useState(false);
  let iconType = "input-icon";
  if (focus || value1 !== "" || value2 !== "") iconType = "input-icon-focus";

  return (
    <div className="input-container">
      <div className={iconType}>{icon}</div>
      <div className="input-col">
        {placeholder}
        <div className="input-row">
          <input
            className="b-c-search-input-pair"
            type="text"
            value={value1}
            onChange={(e) => {
              onChange1(e.target.value);
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            autoComplete="off"
          ></input>
          <input
            className="b-c-search-input-pair-second"
            type="text"
            value={value2}
            onChange={(e) => {
              onChange2(e.target.value);
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            autoComplete="off"
          ></input>
        </div>
      </div>
    </div>
  );
}

DeleteBenchmark.propTypes = {
  selectedBenchmarks: PropTypes.array,
  setBenchmarking: PropTypes.func,
};

export function DeleteBenchmark(props) {
  const { selectedBenchmarks, setBenchmarking } = props;
  let selection = selectedBenchmarks.map((b) => b.id);

  return (
    <button
      className="benchmark-control-delete-button"
      onClick={() => {
        const confirm = window.confirm(
          "Confirm delete " +
            selection.length +
            " benchmark project(s)? This cannot be undone."
        );
        if (confirm) {
          deleteBenchmarking(selection, setBenchmarking);
        }
      }}
    >
      <i className="far fa-trash-alt"></i>
    </button>
  );
}

export function FlagBenchmark(prop) {
  const { selectedBenchmarks } = prop;
  const { setBenchmarking } = prop;
  const { setShow } = prop;
  const { feature } = prop;
  const [error, setError] = useState({});

  const [infoSensLevel, setInfoSensLevel] = useState("");
  const { sensitivityLevelCodes } = useSensitivityLevelCodes();
  const secLevelOptions = [{ label: "Select Case", value: "" }];

  const [companyId, setCompanyId] = useState("");
  const [coordinates, setCoordinates] = useState({});

  sensitivityLevelCodes?.data?.forEach((c) => {
    secLevelOptions.push({ value: c.value, label: c.label });
  });
  let selection = selectedBenchmarks.map((b) => b.id);

  let data = {
    selection: selection,
    setModal: setShow,
    setBenchmarking: setBenchmarking,
    setError: setError,
    sensitivityFlag: infoSensLevel,
    companyId: companyId,
    coordinates: coordinates,
    feature: feature,
  };

  return (
    <div className="benchmark-upload">
      <div className="benchmark-upload-control-container">
        <div className="benchmark-upload-control">
          <TriggerBenchmarkInfoModal
            feature={feature}
            setInfoSensLevel={setInfoSensLevel}
            setCompanyId={setCompanyId}
            setCoordinates={setCoordinates}
          />
        </div>
      </div>
      <div className="general-row-container">
        <Errors error={error} setError={setError} />
      </div>
      <div className="general-button-container">
        <input
          type="button"
          className="general-upload-button"
          onClick={() => {
            switch (feature) {
              case featureEnumerator.COMPANY:
                saveSensitivityCompanyId(data);
                break;
              case featureEnumerator.SENSITIVITY:
                saveSensitivityInformationFlag(data);
                break;
              case featureEnumerator.COORDINATES:
                saveBenchmarkCoordinates(data);
                break;
              default:
                break;
            }
          }}
          value="Save"
        />
      </div>
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
TriggerBenchmarkInfoModal.propTypes = {
  feature: PropTypes.number,
  setInfoSensLevel: PropTypes.func,
  setCompany: PropTypes.func,
  setCompanyId: PropTypes.func,
  setCoordinates: PropTypes.func,
};

function TriggerBenchmarkInfoModal(props) {
  const { feature } = props;
  const { setInfoSensLevel } = props;
  const { setCompany } = props;
  const { setCompanyId } = props;
  const { setCoordinates } = props;

  switch (feature) {
    case featureEnumerator.SENSITIVITY:
      return (
        <InformationSensitivityComponent setInfoSensLevel={setInfoSensLevel} />
      );
    case featureEnumerator.COMPANY:
      return (
        <BenchmarkCompanyComponent
          setCompany={setCompany}
          setCompanyId={setCompanyId}
        />
      );
    case featureEnumerator.COORDINATES:
      return <BenchmarkLocationComponent setCoordinates={setCoordinates} />;
    default:
      return <div>No component</div>;
  }
}

/// props validation | SQ(javascript:S6774)
InformationSensitivityComponent.propTypes = {
  setInfoSensLevel: PropTypes.func,
};
function InformationSensitivityComponent(props) {
  const { setInfoSensLevel } = props;
  const { sensitivityLevelCodes } = useSensitivityLevelCodes();
  const secLevelOptions = [{ label: "Select Case", value: "" }];

  sensitivityLevelCodes?.data?.forEach((c) => {
    secLevelOptions.push({ value: c.value, label: c.label });
  });

  return (
    <div className="benchmark-upload-control-row">
      <div className="benchmark-upload-control-label">Level Of Security:</div>
      <select
        className="benchmark-upload-control-input"
        onChange={(e) => {
          setInfoSensLevel(e.target.value);
        }}
      >
        {selectType(secLevelOptions)}
      </select>
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
BenchmarkCompanyComponent.propTypes = {
  setCompanyId: PropTypes.func,
};

function BenchmarkCompanyComponent(props) {
  const { setCompanyId } = props;
  const [company, setCompany] = useState({});
  return (
    <div className="benchmark-upload-control-row">
      <div className="benchmark-upload-control-label">Select Company:</div>
      <ModalCompany
        Component={CreateProjectSelectClientCompany}
        setFunction={(company) => {
          setCompany(company);
          setCompanyId(company.id);
        }}
        label={<i className="fas fa-building"></i>}
        company={company}
        error={""}
        title={"Client Company"}
        isProjectCreation={true}
      />
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
BenchmarkLocationComponent.propTypes = {
  setCoordinates: PropTypes.func,
};
function BenchmarkLocationComponent(props) {
  const { setCoordinates } = props;
  return (
    <div className="benchmark-upload-control-row">
      <ProjectLocation setCoordinates={setCoordinates} />
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
ExportBenchmark.propTypes = {
  selectedBenchmarks: PropTypes.array,
};

export function ExportBenchmark(props) {
  const { selectedBenchmarks } = props;
  const excelFileName = "benchmark";

  let bmIds = selectedBenchmarks.map((bm) => {
    return {
      benchmark_id: bm.id,
    };
  });
  let { benchmarksWithRows } = useBenchmarksWithRows(bmIds);

  let { TotalSheets, sheetNames } =
    prepareObjectForExcelUpload(benchmarksWithRows);
  return (
    <button
      className="benchmark-control-export-button"
      onClick={() => {
        if (selectedBenchmarks && selectedBenchmarks.length > 0) {
          const confirm = window.confirm(
            "Confirm export " +
              selectedBenchmarks.length +
              " benchmark project(s)?"
          );
          if (confirm) {
            generateBenchmarkInfoExcel(excelFileName, TotalSheets, sheetNames);
          }
        } else {
          window.alert("Please select a benchmark to export.");
        }
      }}
    >
      <i className="fa fa-download" aria-hidden="true"></i>
    </button>
  );
}

function Errors(prop) {
  const { error } = prop;
  return (
    <div className="account-edit-error-container">
      <div className={error.type}>
        <b>{error.text}</b>
      </div>
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
ProjectLocation.propTypes = {
  setCoordinates: PropTypes.func,
};

export function ProjectLocation(props) {
  const { setCoordinates } = props;
  const [lng, setLng] = useState("0");
  const [lat, setLat] = useState("0");
  const [errors] = useState({});

  useEffect(() => {
    setCoordinates({ lng: lng, lat: lat });
  }, [lng, lat, setCoordinates]);

  return (
    <div className="create-project-location-wrapper">
      <div className="create-project-location-container">
        <FieldNumber
          label={translate("Latitude")}
          placeholder={tranStr("Latitude")}
          value={lat}
          onChange={setLat}
          error={errors.Lat}
        />
        <FieldNumber
          label={translate("Longitude")}
          placeholder={tranStr("Longitude")}
          value={lng}
          onChange={setLng}
          error={errors.Lng}
        />
      </div>
      <CreateProjectMap lat={lat} lng={lng} />
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
BasicBenchmark.propTypes = {};
export function BasicBenchmark(props) {
  return <BasicBenchmarkForms {...props} />;
}

/// props validation | SQ(javascript:S6774)
BasicBenchmarkForms.propTypes = {
  selectedBenchmarks: PropTypes.array,
  auth: PropTypes.object,
};
export function BasicBenchmarkForms(props) {
  const { selectedBenchmarks } = props;
  const { auth } = props;
  const [parentErrors, setParentErrors] = useState({});

  const user = auth.user;

  const tabNames = [
    "projectInfo",
    "elementAnalysis",
    "benchmarks",
    "notes",
    "Cost Plan",
    "Visuals",
  ];

  const [tabValue, setTabValue] = React.useState(tabNames[0]);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const [basicBm] = useState(
    !isEmpty(selectedBenchmarks) ? selectedBenchmarks[0] : {}
  );

  const result = useBenchmarkWithRows(
    !isEmpty(selectedBenchmarks) ? selectedBenchmarks[0].id : ""
  );

  if (result?.benchmarkWithRows?.data?.loading) {
    return <Spinner width={"150px"} />;
  }

  if (!isEmpty(selectedBenchmarks) && selectedBenchmarks?.length > 1)
    return (
      <div className="no-multiple-selection">
        <i className="fas fa-exclamation-circle" style={{ color: "red" }}></i>{" "}
        Please choose only one benchmark to edit
      </div>
    );

  return (
    <div className="basic-benchmark-container">
      <Box className="bm-full-width-box-container">
        <Box className="bm-tab-box-container">
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            centered
            aria-label="Benchmark view tabs"
            TabIndicatorProps={{
              style: {
                backgroundColor: "var(--heritage)",
              },
            }}
          >
            <Tab
              label="Project Information"
              value={tabNames[0]}
              style={{ outline: "none" }}
            />
            <Tab
              label="Elemental Analysis"
              value={tabNames[1]}
              style={{ outline: "none" }}
              disabled={isEmpty(basicBm)}
            />
            <Tab
              label="Benchmarks"
              value={tabNames[2]}
              style={{ outline: "none" }}
              disabled={isEmpty(basicBm)}
            />
            <Tab
              label="Notes"
              value={tabNames[3]}
              style={{ outline: "none" }}
              disabled={isEmpty(basicBm)}
            />
          </Tabs>
        </Box>
        <BenchmarkCustomTabPanel value={tabValue} index={tabNames[0]}>
          {isEmpty(selectedBenchmarks) ? (
            <ConfigurableForm
              parentErrors={parentErrors}
              postContractFormType="basicBenchmarkCreationFields"
              urlEndpoint={bmAPIs().update_basic_benchmark_create_fields}
              stateUpdateFunction={() => {}}
              setModal={() => {}}
            />
          ) : (
            <div className="bm-pinfo-container">
              <ConfigurableForm
                parentErrors={parentErrors}
                postContractFormType="basicBenchmarkEditProjectFields"
                benchmarkId={selectedBenchmarks[0]?.id}
                urlEndpoint={
                  bmAPIs().update_benchmark_edit_project_fields +
                  "?benchmarkId=" +
                  selectedBenchmarks[0]?.id
                }
                stateUpdateFunction={() => {}}
                setModal={() => {}}
                hideDeleteAdd={true}
              />
            </div>
          )}
        </BenchmarkCustomTabPanel>
        <BenchmarkCustomTabPanel value={tabValue} index={tabNames[1]}>
          <div>
            {isBenchmarkExists(result) ? (
              <BasicBenchmarkElementUploader
                benchmarkId={selectedBenchmarks[0]?.id}
              />
            ) : (
              <div className="bm-container">
                <ConfigurableForm
                  parentErrors={parentErrors}
                  postContractFormType="elementEditForm"
                  benchmarkId={selectedBenchmarks[0]?.id}
                  urlEndpoint={
                    bmAPIs().update_basic_benchmark_elements +
                    "?benchmarkId=" +
                    selectedBenchmarks[0]?.id
                  }
                  stateUpdateFunction={() => {}}
                  setModal={() => {}}
                  hideDeleteAdd={true}
                />
                <div className="bm-upload-button-container">
                  <UploadButton
                    benchmarkId={selectedBenchmarks[0]?.id}
                    showLocation={"benchmarking"}
                    label={translate("Upload")}
                    Component={BasicBenchmarkElementUploader}
                    stateUpdateFunction={async () => {}}
                  />
                </div>
              </div>
            )}
          </div>
        </BenchmarkCustomTabPanel>
        <BenchmarkCustomTabPanel value={tabValue} index={tabNames[3]}>
          <div className="bm-notes-container">
            <ConfigurableForm
              parentErrors={parentErrors}
              postContractFormType="notesFields"
              benchmarkId={selectedBenchmarks[0]?.id}
              urlEndpoint={
                bmAPIs().update_basic_benchmark_notes +
                "?benchmarkId=" +
                selectedBenchmarks[0]?.id
              }
              stateUpdateFunction={() => {}}
              setModal={() => {}}
            />
          </div>
        </BenchmarkCustomTabPanel>

        <BenchmarkCustomTabPanel value={tabValue} index={tabNames[2]}>
          <div className="bm-metrics-container">
            <ConfigurableForm
              parentErrors={parentErrors}
              postContractFormType="metricsFields"
              benchmarkId={selectedBenchmarks[0]?.id}
              urlEndpoint={
                bmAPIs().update_basic_benchmark_metrics +
                "?benchmarkId=" +
                selectedBenchmarks[0]?.id
              }
              stateUpdateFunction={() => {}}
              setModal={() => {}}
              hideDeleteAdd={true}
            />
          </div>
        </BenchmarkCustomTabPanel>
        <Box className="basic-benchmark-tabs-footer">
          {hasRoles(user.roles, BA_ROLE) && (
            <div className="bm-upload-button-container">
              <PublishButton
                key={selectedBenchmarks[0]?.id}
                benchmarkId={selectedBenchmarks[0]?.id}
                setParentErrors={setParentErrors}
              ></PublishButton>
            </div>
          )}
        </Box>
      </Box>
      <div className="basic-benchmark-footer"></div>
    </div>
  );
}

BasicBenchmarkElementUploader.propTypes = {
  benchmarkId: PropTypes.string,
};
function BasicBenchmarkElementUploader(props) {
  const { benchmarkId } = props;
  return (
    <ConfigurableForm
      postContractFormType="elementalUploadFields"
      setModal={() => {}}
      urlEndpoint={
        bmAPIs().upload_basic_benchmark_elements + "?benchmarkId=" + benchmarkId
      }
      stateUpdateFunction={async () => {}}
    />
  );
}

function isBenchmarkExists(result) {
  return isEmpty(result?.benchmarkWithRows?.data[0]?.rows);
}
